import { SMS_BILLING_METRICS, FIRST_PARTY, UTILITY, MARKETING } from '../constants';
import { Metric } from '../types';

export const isOrgMetric = (metric: Metric) => !metric.project;

export const isProjectMetric = (metric: Metric) => Boolean(metric.project);

export const isCategoryMetric = (metric: Metric) => Boolean(metric.templateCategory);

export const isJourneyMetric = (metric: Metric) => Boolean(metric.journeyId);

export const isPartyMetric = (metric: Metric) => Boolean(metric.billingParty);

export const isProviderMetric = (metric: Metric) =>
  Boolean(metric.providerName && metric.billingParty);

export const isFirstPartyMetric = (metric: Metric) => metric.billingParty === FIRST_PARTY;

export const isCountryMetric = (metric: Metric) => Boolean(metric.recipientCountryName);

export const isOrgLevelSmsMetric = (metric: Metric) =>
  !isPartyMetric(metric) && !isCountryMetric(metric) && !isProjectMetric(metric);

export const isOrgLevelWhatsAppMetric = (metric: Metric) =>
  !isCountryMetric(metric) && !isProjectMetric(metric) && !isCategoryMetric(metric);

export const isOrgLevelWhatsAppUtilityMetric = (metric: Metric) =>
  !isCountryMetric(metric) && !isProjectMetric(metric) && metric.templateCategory === UTILITY;

export const isOrgLevelWhatsAppMarketingMetric = (metric: Metric) =>
  !isCountryMetric(metric) && !isProjectMetric(metric) && metric.templateCategory === MARKETING;

export const isProjectGlobalWhatsAppMetric = (metric: Metric) =>
  isProjectMetric(metric) && isCountryMetric(metric) && !isCategoryMetric(metric);

export const isOrgGlobalWhatsAppCountryUtilityMetric = (metric: Metric) =>
  isOrgMetric(metric) && isCountryMetric(metric) && metric.templateCategory === UTILITY;

export const isOrgGlobalWhatsAppCountryMarketingMetric = (metric: Metric) =>
  isOrgMetric(metric) && isCountryMetric(metric) && metric.templateCategory === MARKETING;

export const isSmsMetric = (metric: Metric) => SMS_BILLING_METRICS.includes(metric.metricName);

export const isOrgGlobalSmsCountryMetric = (metric: Metric) =>
  isOrgMetric(metric) &&
  isCountryMetric(metric) &&
  isSmsMetric(metric) &&
  isFirstPartyMetric(metric);

export const isProjectGlobalSmsMetric = (metric: Metric) =>
  isProjectMetric(metric) &&
  isCountryMetric(metric) &&
  isSmsMetric(metric) &&
  /** Only FirstParty metrics should be shown in the GlobalSms card */
  isFirstPartyMetric(metric);

export const isComprehensiveOrgMetric = (metric: Metric) =>
  isOrgMetric(metric) &&
  !isFirstPartyMetric(metric) &&
  !isCountryMetric(metric) &&
  !isProviderMetric(metric) &&
  !isCategoryMetric(metric);

export const isComprehensiveProjectMetric = (metric: Metric) =>
  isProjectMetric(metric) &&
  !isCountryMetric(metric) &&
  !isProviderMetric(metric) &&
  !isCategoryMetric(metric);
